// extracted by mini-css-extract-plugin
export var challenge = "ChallengesPanel-module--challenge--33c38";
export var challenges = "ChallengesPanel-module--challenges--e0930";
export var date = "ChallengesPanel-module--date--3ba88";
export var description = "ChallengesPanel-module--description--1c6f8";
export var icon = "ChallengesPanel-module--icon--7ed5b";
export var image = "ChallengesPanel-module--image--b6d98";
export var left = "ChallengesPanel-module--left--1c965";
export var picture = "ChallengesPanel-module--picture--7ef6e";
export var right = "ChallengesPanel-module--right--1bf01";
export var root = "ChallengesPanel-module--root--c57cf";
export var spacer = "ChallengesPanel-module--spacer--0d01e";
export var thumb = "ChallengesPanel-module--thumb--0c4c2";
export var title = "ChallengesPanel-module--title--bb7ca";
export var titleBox = "ChallengesPanel-module--titleBox--9b393";
export var titleContainer = "ChallengesPanel-module--titleContainer--579dd";